import _ from 'lodash'
import * as service from '../services'
import {
  createOperationReport,
  validateOperationResponse,
} from './operationReport'

const hasValue = value => value !== '' && value !== null && value !== undefined

const normalizeEstadoRegistro = (value, treeVerified) => {
  if (['no_verificado', 'en_revision', 'verificado'].includes(value)) return value
  return Boolean(parseInt(treeVerified, 10)) ? 'verificado' : 'no_verificado'
}

const cleanRevisionObservations = value => {
  if (!Array.isArray(value)) return []
  return value
    .map(item => ({
      ...item,
      texto: String(item?.texto ?? '').trim(),
    }))
    .filter(item => item.texto)
}

function getListToGeneralCondition(stateInitial, temporal, values) {
  let objToCreation
  const RIESGOS_OTROS = 91
  const OTHERS_ELEMENTS = [86, 87, 88, 89, 90, 91, 92]
  const list1 = _.filter(temporal, o => _.includes([1, 7], o.category))
  const list2 = _.filter(temporal, o => !_.includes([1, 7], o.category))

  _.forEach(list1, object => {
    const currentId = values[object.name]
    if (currentId) {
      // NO CHANGE THE SIMPLE OPERATOR != TO MODE EXTRICT !==
      if (object.initvalue != currentId) {
        let newObj = {}
        if (RIESGOS_OTROS === object.typecategory)
          newObj[object.name] = {
            categorytype: object.typecategory,
            value: currentId,
          }
        else
          newObj[object.name] = {
            categorytype: parseInt(currentId, 10),
            beforeValue: object.initvalue,
          }
        objToCreation = { ...objToCreation, ...newObj }
      }
    }
  })

  _.forEach(list2, object => {
    const currentTypeCategory = object.typecategory
    if (!_.some(stateInitial, ['typecategory', currentTypeCategory])) {
      let newObj = {}
      newObj[object.name] = { categorytype: currentTypeCategory, value: object.initvalue }
      objToCreation = { ...objToCreation, ...newObj }
    } else {
      if (_.includes(OTHERS_ELEMENTS, currentTypeCategory)) {
        const initial = _.find(stateInitial, ['typecategory', currentTypeCategory])
        if (initial.initvalue !== object.initvalue) {
          let newObj = {}
          newObj[object.name] = {
            categorytype: currentTypeCategory,
            value: object.initvalue,
          }
          objToCreation = { ...objToCreation, ...newObj }
        }
      }
    }
  })
  return objToCreation
}

async function savePseudonym(pseudonyms, scientificName, token) {
  if (!pseudonyms.length) return { stored: null }
  const data = _.map(pseudonyms, obj => ({
    nombreComun: obj.name,
    nombreCientifico: scientificName,
  }))
  const response = await service.createPseudonyms(data, token)
  if (Array.isArray(response)) {
    if (_.every(response, ['typeAction', 'creation'])) return { stored: true }
    else {
      const notCreated = _.filter(response, ['typeAction', 'notCreated'])
      const activePseudonym = _.filter(notCreated, obj => Boolean(obj.id))
      if (activePseudonym.length) {
        const dataForActive = _.map(activePseudonym, 'id')
        const responseActivePseudonym = await service.activePseudonymsOfSpecie(
          dataForActive,
          token
        )
        if (Array.isArray(responseActivePseudonym)) {
          if (_.every(responseActivePseudonym, ['typeAction', 'update']))
            return { stored: true }
        }
      }
    }
  }
  return {
    stored: false,
    message: 'Posible actualización fallida. Inténtelo nuevamente.',
  }
}

function buildTreeRegisterData(values, groupsFields, lnglat) {
  const { specieField, siteField, siteAcronym, sectionField } = groupsFields
  const { typeSite_, sitePlace_, alive_, treeVerified_, commit_, prioridadAtencion, codigoManual, modoCodigoPlusCode, referenciaUbicacion_, recorded_ } = values

  const isPlusCodeMode = modoCodigoPlusCode !== false && modoCodigoPlusCode !== 0
  const idTipoZona = typeSite_ !== '#' ? parseInt(typeSite_, 10) : null
  const idTipoSitio = sitePlace_ !== '#' ? parseInt(sitePlace_, 10) : null
  const siteValue = siteField.selected?.label || siteField.selected
  const acronymValue = siteAcronym.selected?.label || siteAcronym.selected
  const sectionValue = sectionField.selected?.label || sectionField.selected || 'S1'
  const estadoRegistro = normalizeEstadoRegistro(values.estadoRegistro, treeVerified_)
  const observacionesRevision = cleanRevisionObservations(values.observacionesRevision)

  return {
    lat: lnglat[1],
    lng: lnglat[0],
    specieId: parseInt(specieField.selected.id, 10),
    sitio: siteValue,
    idTipoZona,
    idTipoSitio,
    comentario: commit_,
    arbolVerificado: estadoRegistro === 'verificado',
    estadoRegistro,
    observacionesRevision:
      estadoRegistro === 'en_revision' ? observacionesRevision : null,
    vivo: Boolean(parseInt(alive_, 10)),
    modoCodigoPlusCode: isPlusCodeMode,
    ...(recorded_ && { recorded: recorded_ }),
    // Campos condicionales según modo
    ...(!isPlusCodeMode && {
      acronimoSitio: acronymValue,
      seccion: sectionValue,
      ...(values.sectionName_ && { nombreSeccion: values.sectionName_ }),
    }),
    ...(!isPlusCodeMode && codigoManual && { codigoManual }),
    // Features opcionales
    ...(values.altitud && { altitud: values.altitud }),
    ...(values.dap && { dap: values.dap }),
    ...(values.ht && { ht: values.ht }),
    ...(values.cap && { cap: values.cap }),
    ...(values.hc && { hc: values.hc }),
    bifurcaciones: hasValue(values.bifurcaciones) ? Number(values.bifurcaciones) : 1,
    ...(hasValue(values.inclArbol) && { inclArbol: values.inclArbol }),
    ...(hasValue(values.compInclArbol) && { compInclArbol: values.compInclArbol }),
    ...(values.copaNS && { copaNS: values.copaNS }),
    ...(values.copaEW && { copaEW: values.copaEW }),
    ...(values.follaje && { follaje: values.follaje }),
    ...(values.madurez && { madurez: values.madurez }),
    ...(values.floracion && { floracion: values.floracion }),
    ...(values.fructificacion && { fructificacion: values.fructificacion }),
    ...(values.fusteRectitud && { fusteRectitud: values.fusteRectitud }),
    ...(values.espaciamiento && { espaciamiento: values.espaciamiento }),
    ...(prioridadAtencion && { prioridadAtencion }),
    ...(referenciaUbicacion_ && { referenciaUbicacion: referenciaUbicacion_ }),
  }
}

/**
 * Envío único para el WizardV2: árbol + features + inconvenientes en un solo JSON.
 * El backend debe procesar el campo `inconveniences` dentro del endpoint registerComplete.
 *
 * Payload enviado:
 *   { lat, lng, specieId, sitio, ..., inconveniences: { calidadRaiz: {...}, rsgoCaida: {...}, ... } }
 */
export async function submitTreeRegistrationV2({
  values,
  temporal,
  stateInitial,
  groupsFields,
  token,
  lnglat,
}) {
  const { specieField, pseudonymField } = groupsFields
  const { label: scientificName } = specieField.selected
  const { error: errPseudonym, selected: selectedPs } = pseudonymField

  // Construir inconvenientes
  const inconveniences = getListToGeneralCondition(stateInitial, temporal, values)

  // Construir payload completo en un solo objeto
  const payload = {
    ...buildTreeRegisterData(values, groupsFields, lnglat),
    // Inconvenientes incluidos en el mismo JSON
    ...(inconveniences && Object.keys(inconveniences).length > 0 && { inconveniences }),
  }

  const response = await service.registerTreeComplete(payload, token)
  const validation = validateOperationResponse(response, {
    successActions: ['created'],
    fallbackMessage: response?.message || 'Error al registrar el árbol',
  })

  if (!validation.ok) {
    return {
      stored: false,
      message: validation.message,
      treeId: response?.tree?.id || response?.treeId || response?.operationReport?.treeId,
      treeCreated:
        response?.operationReport?.report?.tree?.ok === true ||
        response?.treeCreated === true,
      operationReport: response?.operationReport || {
        action: 'created',
        ok: false,
        treeId: response?.tree?.id || response?.treeId || null,
        report: validation.report || createOperationReport({
          tree: { ok: false, message: validation.message },
        }),
      },
    }
  }

  const treeId = response.tree?.id
  const treeCode = response.tree?.codigo

  // Guardar sugerencias de pseudónimos nuevos (llamada separada, solo metadatos)
  const allSelected = !errPseudonym && Array.isArray(selectedPs) ? [...selectedPs] : []
  const newSuggestions = allSelected.filter(item => !item.id)
  const pseudonymResult = await savePseudonym(newSuggestions, scientificName, token)

  return {
    stored: true,
    treeId,
    treeCode,
    operationReport: response.operationReport || {
      action: 'created',
      ok: true,
      treeId,
      report: createOperationReport(),
    },
    warnings:
      pseudonymResult?.stored === false
        ? [pseudonymResult.message || 'No se pudieron guardar algunos pseudónimos sugeridos.']
        : [],
  }
}
